import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postTravelAddonStart,
  postTravelAddonSuccess,
  postTravelAddonFailure,
} from "../reducers/postTravelAddonReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postTravelAddon = createAsyncThunk(
  "postTravelAddon",
  async ({ data }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postTravelAddonStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/Travel/SaveAddon`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set content type if necessary
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postTravelAddonSuccess(responseData?.data?.result));
      console.log(
        responseData?.data?.result,
        "<=========responseData?.data?.result"
      );
      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postTravelAddonFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
